/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import PhoneDesignPage from './pages/PhoneDesignPage';
import CupDesignPage from './pages/CupDesignPage';
import CupCustomizerPage from './pages/CupCustomizerPage';
import HistoryPage from './pages/HistoryPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import SystemSettings from './pages/admin/SystemSettings';
import TemplateManager from './pages/admin/TemplateManager';
import BillingDashboard from './pages/admin/BillingDashboard';
import TopupPage from './pages/admin/TopupPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import { UpdateBanner } from './components/UpdateBanner';
import { BillingBanner } from './components/BillingBanner';
import NotificationProvider from './components/Notification/NotificationProvider';

const App: React.FC = () => {
  // Log app mount
  React.useEffect(() => {
    console.log('[App] ============================================');
    console.log('[App] App component mounted', {
      timestamp: new Date().toISOString(),
      pathname: window.location.pathname,
      search: window.location.search
    });
    console.log('[App] ============================================');
  }, []);

  return (
    <NotificationProvider>
      <BrowserRouter>
        <UpdateBanner />
        <BillingBanner />
        <Routes>
        {/* Main Cup Customizer as Landing Page */}
        <Route path="/" element={<CupCustomizerPage />} />
        <Route path="/cup-customizer" element={<CupCustomizerPage />} />

        {/* Legacy Routes (Backwards Compatibility) */}
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/phone-case" element={<PhoneDesignPage />} />
        <Route path="/cup" element={<CupDesignPage />} />
        <Route path="/history" element={<HistoryPage />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/templates"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <TemplateManager />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/billing"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <BillingDashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <SystemSettings />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/topup"
          element={
            <ProtectedRoute>
              <TopupPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      </BrowserRouter>
    </NotificationProvider>
  );
};

export default App;
